import { HttpClient, HttpEventType, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as FileSaver from 'file-saver';
import { BehaviorSubject, Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ScanType } from 'src/app/Models/ScanType';
import { ApiHttpService } from 'src/app/Service/api.http.service';
import { AuthService } from 'src/app/Service/auth.service';
import { LoadingService } from 'src/app/Service/loading.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { APIEndPoints } from 'src/app/utils/api-endpoint';
import { environment } from 'src/environments/environment';
import { AddGetNameComponent } from '../../Components/files/documents/get-name/get-name.component';
import { ShareUploadLinkComponent } from '../../Components/files/documents/share-upload-link/share-upload-link.component';
import { ShareLinkComponent } from '../../Components/files/documents/sharelink/sharelink.component';
import { ShareToFamilyComponent } from '../../Components/files/documents/shareToFamily/shareToFamily.component';
import { UserService } from '../../Service/user.service';
import html2canvas from 'html2canvas';
import jspdf from 'jspdf';
import { DeleteComponent } from '../../Components/files/documents/delete/delete.component';
import { LoggingService } from 'src/app/Service/logging.service';
@Injectable({
  providedIn: 'root',
})
export class FilesService {
  currentFolderInfo;
  allFiles: any[] = [];
  forceRefresh$: BehaviorSubject<string> = new BehaviorSubject('');
  addFolder$: Subject<boolean> = new Subject();
  fileInfo$: Subject<boolean> = new Subject();
  otpContnet;
  selectedUser;
  hasFiles = 1;
  userIndex = -1;
  breadCrumData = [];
  baseFileInfo;
  IDsFolders = [];
  uploadedFile = null;
  bearertoken;
  historyInfo = [];
  state: string = 'Alabama';
  search: string;
  videoCategory;
  categoryId;
  constructor(
    private readonly http: HttpClient,
    private readonly _apiService: ApiHttpService,
    private readonly notify: NotificationService,
    private readonly auth: AuthService,
    private readonly dialog: NgbModal,
    private readonly sanitizer: DomSanitizer,
    private readonly loderService: LoadingService,
    private readonly userService: UserService,
    private readonly router: Router,
    public modalService: NgbModal,
    public logging: LoggingService,
  ) {
    this.auth.getTokenSilently$().subscribe((token) => {
      this.bearertoken = token;
    });
  }
  isIdsFolder = () => this.breadCrumData.find((i) => i.name === 'IDs');
  isInvoiceFolder = () => this.breadCrumData.find((i) => i.name === 'Invoice');
  get IsPhotowithAlubm() {
    return this.router.url.endsWith('/user/photosvideos/album');
  }
  addBreadcrumItem(isUser = false) {
    if (isUser && this.selectedUser)
      this.breadCrumData.push({
        ...this.currentFolderInfo,
        name: this.selectedUser.firstName,
      });
    else this.breadCrumData.push({ ...this.currentFolderInfo });
  }
  sanitize = (data) => this.sanitizer.bypassSecurityTrustResourceUrl(data);
  saveHistory() {
    this.historyInfo.push(
      this.currentFolderInfo
        ? {
            currentFolderInfo: { ...this.currentFolderInfo },
            breadCrumData: [...this.breadCrumData],
          }
        : { breadCrumData: [...this.breadCrumData] },
    );
  }
  refresh() {
    this.forceRefresh$.next(Math.random.toString());
  }
  getsfdt(fileId): any {
    return this._apiService
      .get(APIEndPoints.Files + '/ImportFile/' + fileId)
      .pipe();
  }
  getblob(url): any {
    return this._apiService.getBlob(url).pipe();
  }
  saveFile(file, blob, isTpa, familyId): any {
    const formData = new FormData();
    formData.append('file', new File([blob], file.name));
    formData.append(
      'value',
      JSON.stringify({ fileId: file.id, isTPA: isTpa, familyId: familyId }),
    );
    return this._apiService
      .post(APIEndPoints.Files + '/SaveFile', formData)
      .pipe();
  }

  downloadFile(file): any {
    if (file.location) window.open(file.location, '_blank');
    else {
      const html = `<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><title>${file.fileName}</title></head><body>
        ${file.notes}
        </body></html>`;

      const blob = new Blob(['\ufeff', html], {
        type: 'application/msword',
      });

      FileSaver.saveAs(blob, `${file.fileName.trim()}.rtf`);
    }
  }
  progress = 0;
  async getFileName() {
    let dialogRef = this.dialog.open(AddGetNameComponent, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
      size: 'lg',
    });
    dialogRef.componentInstance.file = 'Enter the File name';
    return await dialogRef.closed.toPromise();
  }
  async upload(
    file: any,
    onCancel = null,
    getFiles = false,
    folderId = null,
  ): Promise<boolean> {
    this.progress = 1;
    const formData = new FormData();
    if (file?.name || file?.length) {
      if (file.name) {
        formData.append('file', file);
      } else {
        for (const item of file) {
          formData.append('file[]', item);
        }
      }
      formData.append(
        'value',
        JSON.stringify(
          this.selectedUser || this.currentFolderInfo.name == 'Invoice'
            ? {
                folderId:
                  folderId ||
                  (this.currentFolderInfo ? this.currentFolderInfo.id : null),
                fileName: file.name,
                userId: this.selectedUser?.id,
                scan: true,
                ScanMode: this.isInvoiceFolder() ? ScanType.Invoices : null,
              }
            : {
                folderId:
                  folderId ||
                  (this.currentFolderInfo ? this.currentFolderInfo.id : null),
                fileName: file.name,
              },
        ),
      );
      const headers = new HttpHeaders({
        Authorization: `Bearer ${this.bearertoken}`,
      });
      await this.http
        .post(
          file.name
            ? `${environment.serviceURL}${APIEndPoints.Files}`
            : `${environment.serviceURL}${APIEndPoints.Files}/v4`,
          formData,
          {
            reportProgress: true,
            observe: 'events',
            headers: headers,
          },
        )
        .pipe(
          map((event: any) => {
            if (event.type == HttpEventType.UploadProgress) {
              this.progress = Math.round((100 / event.total) * event.loaded);
            } else if (event.type == HttpEventType.Response) {
              this.notify.showSuccess('Uploaded successfully');
              this.progress = null;
              if (getFiles) this.refresh();
              else if (onCancel) onCancel.emit(true);
              this.uploadedFile = event.body.data;
            }
          }),
          catchError((err: any) => {
            this.progress = null;
            this.notify.showError(err.message);
            return null;
          }),
        )
        .toPromise();
      return true;
    }
  }
  async uploadLegacy(file: File, value: string): Promise<boolean> {
    if (!file) this.loderService.ShowLoading();
    this.progress = 1;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('value', value);
    const headers = new HttpHeaders({
      Authorization: `Bearer ${this.bearertoken}`,
    });
    await this.http
      .post(`${environment.serviceURL}/api/Files/V2`, formData, {
        reportProgress: true,
        observe: 'events',
        headers: headers,
      })
      .pipe(
        map((event: any) => {
          if (event.type == HttpEventType.UploadProgress) {
            this.progress = Math.round((100 / event.total) * event.loaded);
          } else if (event.type == HttpEventType.Response) {
            this.notify.showSuccess(
              file ? 'Updated successfully' : 'Uploaded successfully',
            );
            this.userService.GetUserInfo().toPromise();
            this.progress = null;
          }
        }),
        catchError((err: any) => {
          this.progress = null;
          this.notify.showError(err.message);
          return null;
        }),
      )
      .toPromise();
    return true;
  }

  /**
   * Upload a Legacy Message via the V10 endpoint.
   *
   *   POST /api/Files/v10  (multipart/form-data)
   *     - value: JSON metadata string (always required)
   *     - file:  binary  (omit for Letter, required for Video/Voice/Photo)
   *
   * Returns the created file Guid (response.data) so the caller can chain
   * subsequent uploads — Photo Album sends one request per photo with the
   * same albumGroupId.
   */
  async uploadLegacyV10(
    file: File | null,
    value: string,
  ): Promise<string | null> {
    if (!file) this.loderService.ShowLoading();
    this.progress = 1;
    const formData = new FormData();
    if (file) formData.append('file', file);
    formData.append('value', value);
    const headers = new HttpHeaders({
      Authorization: `Bearer ${this.bearertoken}`,
    });
    let resultId: string | null = null;
    await this.http
      .post(`${environment.serviceURL}/api/Files/v10`, formData, {
        reportProgress: true,
        observe: 'events',
        headers,
      })
      .pipe(
        map((event: any) => {
          if (event.type === HttpEventType.UploadProgress) {
            this.progress = Math.round((100 / event.total) * event.loaded);
          } else if (event.type === HttpEventType.Response) {
            resultId = event?.body?.data ?? null;
            this.progress = null;
          }
        }),
        catchError((err: any) => {
          this.progress = null;
          throw err;
        }),
      )
      .toPromise();
    if (!file) this.loderService.HideLoading();
    return resultId;
  }

  ShareSecureLink(data) {
    return this._apiService
      .post(APIEndPoints.Files + '/ShareSecureLink', data)
      .pipe();
  }
  getDataRules() {
    return this._apiService.get(APIEndPoints.Files + '/getDataRules').pipe();
  }
  GetFolderInfo() {
    return this._apiService.get(APIEndPoints.Family + '/Folders').pipe();
  }
  GetVideoCategory() {
    return this._apiService
      .get(APIEndPoints.Files + '/GetVideoCatagory')
      .pipe();
  }
  AddFolder(data) {
    return this._apiService
      .post(`${APIEndPoints.Family}/AddFolder`, data)
      .pipe();
  }

  CreateDocumentNotes(data) {
    return this._apiService.post(APIEndPoints.FamilyNotes, data).pipe();
  }
  UpdateDocumentNotes(data) {
    return this._apiService
      .put(`${APIEndPoints.FamilyNotes}/${data.id}`, data)
      .pipe();
  }

  GetDocumentNotes(folderId, userId) {
    return this._apiService
      .get(`${APIEndPoints.FamilyNotes}/${folderId}/${userId}`)
      .pipe();
  }
  DeleteDocumentNotes(fileId) {
    return this._apiService
      .delete(`${APIEndPoints.FamilyNotes}/${fileId}`)
      .pipe();
  }

  GetFileInfo(fielId) {
    return this._apiService.get(`${APIEndPoints.Files}/` + fielId).pipe();
  }
  GetFileV2Info(fielId) {
    return this._apiService.get(`${APIEndPoints.Files}/v2/` + fielId).pipe();
  }
  ShareToOther(data) {
    return this._apiService
      .post(`${APIEndPoints.Files}/ShareToOther/`, data)
      .pipe();
  }
  DeleteShareToOther(id) {
    return this._apiService
      .delete(`${APIEndPoints.Files}/DeleteShareToOther/${id}`)
      .pipe();
  }
  DeleteFile(fielId) {
    return this._apiService.delete(`${APIEndPoints.Files}/` + fielId).pipe();
  }
  DeleteFolder(folderId) {
    return this._apiService
      .delete(`${APIEndPoints.Family}/DeleteFolder/` + folderId)
      .pipe();
  }
  UpdateFile(fileData) {
    return this._apiService.post(`${APIEndPoints.Files}/Update`, fileData);
  }

  GetAllFiles(
    folderId,
    userId,
    baseFolderId,
    pageNumber = 1,
    pageSize = 10,
    state,
    search = '',
  ) {
    return this._apiService
      .post(`${APIEndPoints.Files}/GetAllFilesWithPagination`, {
        folderId,
        userId,
        baseFolderId,
        pageNumber,
        pageSize,
        state,
        search: search || '',
      })
      .pipe();
  }
  GetSubFolderInfo(folderId, userId = null) {
    return this._apiService
      .get(`${APIEndPoints.Family}/SubFolders/${folderId}/${userId ?? ''}`)
      .pipe();
  }
  GetVaultFiles(
    pageNumber: number = 1,
    pageSize: number = 10,
    search: string = '',
    downloadBase: string = '',
  ) {
    return this._apiService.post(`${APIEndPoints.Files}/GetVaultFiles`, {
      pageNumber,
      pageSize,
      search: search || '',
      downloadBase: downloadBase || '',
    });
  }
  GetFileShareLink(folderId) {
    return this._apiService
      .get(`${APIEndPoints.Files}/GetFileShareLink/` + folderId)
      .pipe();
  }
  UpdateMetadata(data) {
    return this._apiService
      .put(`${APIEndPoints.Files}/UpdateMetadata/`, data)
      .pipe();
  }
  SecureFileShare(data) {
    return this._apiService
      .post(`${APIEndPoints.Files}/SecureFileShare`, data)
      .pipe();
  }

  ShareToUser(data) {
    return this._apiService
      .post(`${APIEndPoints.Files}/ShareToUser`, data)
      .pipe();
  }

  async getShareSecureLink(obj) {
    const dialogRef = this.currentFolderInfo.isSecure
      ? this.dialog.open(ShareToFamilyComponent, {
          centered: true,
          backdrop: 'static',
          keyboard: false,
          size: 'lg',
        })
      : this.dialog.open(ShareLinkComponent, {
          centered: true,
          backdrop: 'static',
          keyboard: false,
        });
    dialogRef.componentInstance.fileid = obj.id;
    dialogRef.componentInstance.folderId = obj.folderId;
    dialogRef.componentInstance.creatorId = obj.creator;

    return dialogRef.closed.toPromise().then((resp) => {
      return true;
    });
  }
  async getShareToUser(id) {
    const dialogRef = this.dialog.open(ShareToFamilyComponent, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
    dialogRef.componentInstance.fileid = id;

    return dialogRef.closed.toPromise().then((resp) => {
      return true;
    });
  }

  async ShareUploadLink(folder) {
    const dialogRef = this.dialog.open(ShareUploadLinkComponent, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
      size: 'md',
    });
    dialogRef.componentInstance.folderid = folder.id;
    return dialogRef.closed.toPromise().then((resp) => {
      return true;
    });
  }

  FileUploadRequest(data) {
    return this._apiService
      .post(`${APIEndPoints.Files}/FileUploadRequest`, data)
      .pipe();
  }

  isShareUploadLink(folderName) {
    // const emergencyCondition = this.router.url.includes('emergency');
    let folderList = ['Password Manager'];
    if (
      folderName != 'Secure Password Storage' &&
      folderName != 'After-Life Planning' &&
      folderName != 'Medical Records Information' &&
      folderName != 'List of Medical contacts'
      //  && !emergencyCondition
    )
      return !folderList.includes(folderName);
  }

  RenameFolder(req) {
    return this._apiService
      .patch(`${APIEndPoints.Files}/RenameFolder`, req)
      .pipe();
  }

  async RenameDefaultFolder(folder) {
    let dialogRef = this.dialog.open(AddGetNameComponent, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
    dialogRef.componentInstance.name = folder.name;
    const data = await dialogRef.closed.toPromise();
    if (data) {
      const req = {
        Id: folder.id,
        Name: data,
      };
      this.RenameFolder(req).subscribe((res) => {
        if (res) {
          this.notify.showSuccess('Updated successfully');
          this.refresh();
        }
      });
    }
  }

  async deleteFolder(info) {
    let dialogRef = this.dialog.open(DeleteComponent, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
    dialogRef.componentInstance.info = { id: info.id, name: info.name };
    const data = await dialogRef.closed.toPromise();
    if (data) {
      this.DeleteFolder(data).subscribe((res) => {
        if (res) {
          this.refresh();
          this.notify.showSuccess('Your file has been successfully deleted.');
        }
      });
    }
  }

  async renameFile(file) {
    const dialogRef = this.openDialog();
    dialogRef.componentInstance.name = file?.notes ? file.fileName : file.name;
    dialogRef.componentInstance.file = 'Enter the File name';
    const data = await dialogRef.closed.toPromise();
    if (data) {
      const req = this.createRenameRequest(file, data);
      const result = file?.notes
        ? await this.userService.RenameFamilyNote(req).toPromise()
        : await this.userService.RenameFile(req).toPromise();
      this.handleRenameResult(result);
    }
  }

  openDialog() {
    return this.dialog.open(AddGetNameComponent, {
      centered: true,
      backdrop: 'static',
      keyboard: false,
    });
  }

  createRenameRequest(file, newName) {
    let fileName;
    if (file?.notes || newName.includes(file.extension)) {
      fileName = newName;
    } else {
      fileName = newName + file.extension;
    }
    return {
      FileId: file.id,
      FileName: fileName,
    };
  }

  handleRenameResult(result) {
    if (result) {
      this.notify.showSuccess('You have successfully renamed the file.');
      this.refresh();
    }
  }

  infoContent = [
    {
      name: 'List of Medical contacts',
      message: 'Create a list of your medical providers contact information.',
    },
    {
      name: 'Medical',
      message: `Click your name to upload medical records to share with your family. Click on the names of family members to view the medical records they have shared.`,
      subscriberMessage: `This is your medical records library. Click on one of the folders below to add medical records or create your
      own folder by clicking add and the folder icon above. `,
    },
    {
      name: 'Important Contacts',
      message:
        'Click the Add button and select the phone icon in the top, right corner to the enter names, phone numbers, and email addresses for all the important people in your life.',
    },
    {
      name: 'Insurance',
      message: `This is your insurance dashboard. Click on your name to upload documents or photos to share within your family. Click on a family member's names to view documents and photos they have shared.`,
      subscriberMessage: `Click the folders below to add insurance documents, or create your own folder by clicking the Add button in the top, right corner.`,
    },
    {
      name: 'IDs',
      message: `This is your ID & Document library dashboard. Click on your name to upload IDs and documents to share within your family. Click on a family member's names to view IDs and documents they have shared.`,
      subscriberMessage: `This is your ID & document library. Click on one of the folders below to add IDs and documents, or create your
      own folder by clicking add and the folder icon above.`,
    },
    {
      name: 'Photo & Video Library',
      message: `Click your name to upload photos and videos to share with your family. Click on the names of family members to view the photos and videos they have shared.`,
      subscriberMessage: `Click Add to create a new album folder, upload a photo or video, create a sticky note, or take a photo or video. You also have the option to drag and drop files into your library.`,
    },
    {
      name: 'Worldwide Emergency Numbers',
      message: `Search for emergency contact numbers across the globe.`,
    },
    {
      name: 'Finance',
      message: `Click your name to upload financial records to share with your family. Click on the names of family members to view the financial records they have shared.`,
    },
    {
      name: 'Emergency Prep',
      message: `To add a new folder, simply click on the “Add” button in the top, right corner.`,
    },
  ];

  foldersArray = [
    'Passport',
    'Driving license',
    'Umbrella Policy',
    'Invoice',
    'Pet Insurance',
    'Home Insurance',
    'Life Insurance',
    'Car Insurance',
    'Pet Wallet ID',
    'Pet wallet ID',
    'Travelers ID',
    'Military ID',
    'Birth certificate',
    'Social security card',
    'Immunizations',
    'Health Insurance',
    'Vaccine Cards',
  ];

  async CreatePDF(htmlContent, filename) {
    await html2canvas(htmlContent).then(async (canvas) => {
      const contentDataURL = canvas.toDataURL('image/png');
      let position = 0;
      let pdf = new jspdf('p', 'pt', [canvas.width - 100, canvas.height - 100]);
      let pdfWidth = pdf.internal.pageSize.getWidth();
      let pdfHeight = pdf.internal.pageSize.getHeight();
      pdf.addImage(contentDataURL, 'PNG', 0, position, pdfWidth, pdfHeight);
      const blob = pdf.output('blob');
      let file = new File([blob], filename, { type: 'application/pdf' });
      await this.upload(file, null, true, this.currentFolderInfo?.id);
    });
  }
  infoButton(folderName) {
    return (
      this.router.url.endsWith('/personalvault') ||
      this.router.url.endsWith('/files') ||
      this.router.url.endsWith('/photosvideos') ||
      this.router.url.endsWith('/legacyvideo') ||
      this.router.url.endsWith('/emergency') ||
      this.router.url.endsWith('/emergency/contacts') ||
      this.router.url.endsWith('/emergency/familyhealthcards') ||
      this.router.url.endsWith('/emergency/document') ||
      this.router.url.endsWith('/emergency/worldwideemergencynumbers') ||
      this.router.url.endsWith('/files/selectuser') ||
      this.router.url.endsWith('/files/document') ||
      this.router.url.endsWith('/files/contacts') ||
      folderName == 'Shared with Me'
    );
  }
  TPAFileShare(data) {
    return this._apiService
      .post(`${APIEndPoints.Professional}/TPAFileShare`, data)
      .pipe();
  }
}
